import ApiClient from './ApiClient';

class IntimacoesAPI extends ApiClient {
  constructor() {
    super('intimacoes', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  toggleRead(id) {
    return axios.patch(`${this.url}/${id}/toggle_read`);
  }

  toggleFavorite(id) {
    return axios.patch(`${this.url}/${id}/toggle_favorite`);
  }

  bulkUpdate(data) {
    return axios.post(`${this.url}/bulk_update`, data);
  }

  getSummary() {
    return axios.get(`${this.url}/summary`);
  }

  searchTargets(q) {
    return axios.get(`${this.url}/search_targets`, { params: { q } });
  }

  linkConversation(id, data) {
    return axios.post(`${this.url}/${id}/link_conversation`, data);
  }

  getAdvogados() {
    return axios.get(`${this.url}/advogados`);
  }

  saveAdvogados(data) {
    return axios.post(`${this.url}/advogados`, data);
  }
}

export default new IntimacoesAPI();
